"use client"

/**
 * Keeps a user who must enrol in MFA on the enrolment surface (see
 * `@/shared/lib/mfa-route-lock`). Mounted once around the app shell in the
 * root layout. While the lock is set, any route but `/security/mfa-setup`
 * renders nothing and is replaced by the setup page, so no other screen paints,
 * not even from the back button or the router cache.
 */
import { useEffect, type ReactNode } from "react"
import { usePathname, useRouter } from "next/navigation"
import { MFA_SETUP_PATH, useMfaRouteLocked } from "@/shared/lib/mfa-route-lock"

export function MfaRouteGuard({ children }: { readonly children: ReactNode }) {
  const locked = useMfaRouteLocked()
  const pathname = usePathname()
  const router = useRouter()
  const offSetupPage = locked && pathname !== MFA_SETUP_PATH

  useEffect(() => {
    if (offSetupPage) router.replace(MFA_SETUP_PATH)
  }, [offSetupPage, router])

  if (offSetupPage) return null
  return <>{children}</>
}
